<ion-header [translucent]="true">
    <ion-toolbar class="ion-padding-end">
        <ion-title *ngIf="Title">{{Title}}</ion-title>

        <ion-button title="fechar" style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end"
            (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>

    <ion-toolbar>
        <ion-grid class="ion-no-padding">
            <ion-row class="ion-padding-horizontal">
                <ion-searchbar placeholder="pesquisar" (ionInput)="OnSearch($event)" [disabled]="!HasItems"
                    i18n-placeholder=":@@modal_simple_list.search-placeholder"></ion-searchbar>
            </ion-row>
        </ion-grid>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" [fullscreen]="true">

    <!-- aviso: mesmo estilo do aviso do resumo de consumo -->
    <ion-row class="alert-warning" *ngIf="Description && HasItems">
        <ion-icon name="warning-outline"></ion-icon>
        <p>{{Description}}</p>
    </ion-row>

    <p class="list-total" *ngIf="Filtered.length>0" i18n=":@@modal_simple_list.total">Total: {{Filtered.length}}</p>

    <!-- listas muito grandes: renderiza por blocos, carregando mais ao chegar ao fim do scroll -->
    <div class="list-chips" *ngIf="Filtered.length>0">
        <ion-chip *ngFor="let item of Filtered | slice:0:Limit; trackBy: TrackByIndex" [title]="item?.Name||''">
            <ion-label>{{item?.Name||'--'}}</ion-label>
        </ion-chip>
    </div>

    <ion-infinite-scroll threshold="150px" [disabled]="Limit >= Filtered.length" (ionInfinite)="OnLoadMore($event)">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
    </ion-infinite-scroll>

    <!-- lista sem nenhum item -->
    <no-items *ngIf="!HasItems" [description]="EmptyDescription || 'sem registos'"></no-items>

    <!-- pesquisa sem resultados -->
    <no-items *ngIf="HasItems && Filtered.length==0"></no-items>

</ion-content>
